import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {ErrorBoundary} from "../../core/error/boundary/ErrorBoundary";
import GeneralError from "../../core/error/display/GeneralError";
import AppRoutes from "./AppRoutes";

const PageError = () => {
    return (
        <div className="body">
            <GeneralError />
        </div>
    )
}

function AppWeb() {

    return (
        <BrowserRouter>
            <div className="App">
                <ErrorBoundary fallBack={<PageError/>}>
                    <AppRoutes />
                </ErrorBoundary>
            </div>
        </BrowserRouter>
    );
}

export default AppWeb;
